import { render, staticRenderFns } from "./MyImgText2Edit.vue?vue&type=template&id=78a65ce4&scoped=true"
import script from "./MyImgText2Edit.vue?vue&type=script&lang=js"
export * from "./MyImgText2Edit.vue?vue&type=script&lang=js"
import style0 from "./MyImgText2Edit.vue?vue&type=style&index=0&id=78a65ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a65ce4",
  null
  
)

export default component.exports